import {Component, HostListener} from "@angular/core";
import {CTATypes, Language, PageType} from "./model/common.enum";
import {ActivatedRoute, Router} from "@angular/router";
import {RouteConstants} from "./constants/route-constants";
import {TranslateService} from "@ngx-translate/core";
import {StorageService} from "./services/storage.service";

@Component({
  selector: "rch-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent {
  title = "connectedhome-appbased-auth";
  tabPressCtr = 0;
  constructor(
    private storageService: StorageService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    translateService.addLangs([Language.EN, Language.FR]);
    translateService.setDefaultLang(Language.EN);

    const signInLang = storageService.getLanguage(true);
    const language = storageService.getLanguage(false);
    let lang = signInLang ? signInLang : language;
    if (!lang) {
      lang = Language.EN;
      storageService.setLanguage(lang);
    }
    translateService.use(lang);
  }

  navigateTo(route: PageType) {
    let routeTo = [];
    switch (route) {
      case PageType.ACCOUNT_SELECTION: {
        routeTo = [RouteConstants.accountSelection.self];
        break;
      }
      case PageType.ACTIVATE: {
        routeTo = [RouteConstants.activate.self];
        break;
      }
      default: {
        routeTo = [RouteConstants.login.self];
        break;
      }
    }

    this.router.navigate(routeTo);

  }

  @HostListener("focusin", ["$event"])
  handleKeypress(event: KeyboardEvent) {
    const skipToContent = document.getElementById("skipToContent");
    const header = document.getElementById("appBasedTvHeader");
    const currElem = event.target as HTMLElement;

    if (currElem === skipToContent) {
      skipToContent.focus();
      skipToContent.className = "btn-skip active cdk-focused cdk-keyboard-focused";
      header.className = "appbased-tv__header with-skip"
    } else {
      skipToContent.className = "btn-skip";
      header.className = "appbased-tv__header"
    }
  }

  protected readonly PageType = PageType;
  protected readonly CTATypes = CTATypes;
}
